import React, { useContext, useEffect, useMemo } from "react";

import {
  Context,
  fetchCompletionStatuses,
  fetchLessonRetrospectives,
  fetchLessonVideoChapters,
  postCompletedLesson,
  postLessonRetrospectives,
} from "../../../teacherStore";
import VideoLesson from "../../../templates/teacher/VideoLesson";
import { parseQueryParams } from "../../../libs/Util";

export default () => {
  const { state, dispatch } = useContext(Context);

  const lessonId = parseInt(parseQueryParams()["lesson"]);
  const playingChapterId = parseInt(parseQueryParams()["chapter"]);
  const classListInParams = parseQueryParams()["classList"];
  // レンダリングのたびにclassListが異なるメモリに作成され
  // 再度useEffect内の処理が実行してしまうためメモ化
  const classList = useMemo<number[]>(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : [],
    [classListInParams],
  );

  const isLessonCompleted =
    state.completion_statuses.completion_statuses.length === 0 ||
    state.completion_statuses.completion_statuses.some(
      status => status.is_completed,
    );

  const postCompletedLessonFunc = () => {
    dispatch(postCompletedLesson(classList, lessonId));
  };

  const postCompletedLessonRetrospectivesFunc = (
    score: number,
    lessonDeliveryScore: number,
    groupWorkScore: number | null,
  ) => {
    dispatch(
      postLessonRetrospectives(
        state.teacher.id,
        classList.join(),
        lessonId,
        score,
        lessonDeliveryScore,
        groupWorkScore,
      ),
    );
  };

  useEffect(() => {
    dispatch(fetchCompletionStatuses(classList, lessonId));
    dispatch(fetchLessonRetrospectives(classList.join(), lessonId));
  }, [dispatch, classList, lessonId]);

  // チャプター切り替え時にワークの完了状態を再取得するため
  // 依存配列にplayingChapterIdを含めている
  useEffect(() => {
    dispatch(fetchLessonVideoChapters(classList, lessonId));
  }, [dispatch, classList, lessonId, playingChapterId]);

  return state.lesson_video_chapters ? (
    <VideoLesson
      lessonVideoChapters={state.lesson_video_chapters}
      playingChapterId={playingChapterId}
      classList={classList}
      prevLessonId={state.prev_lesson_id}
      nextLessonId={state.next_lesson_id}
      isLessonCompleted={isLessonCompleted}
      teacherLessonRetrospectives={state.teacher_lesson_retrospectives}
      postCompletedLesson={postCompletedLessonFunc}
      postCompletedLessonRetrospectives={postCompletedLessonRetrospectivesFunc}
    />
  ) : null;
};
